<template>
  <el-dialog title="添加京东外卖商家" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <div style="max-height: 65vh;overflow-y: auto;">
      <div v-for="(item, index) in formData" :key="index">
        <el-form :ref="'valiForm' + index" size="small" :model="item">
          <el-form-item label="商家编号" prop="merchantId" :label-width="formLabelWidth" :rules="{
            required: true, message: '商家编号不能为空', trigger: 'blur'
          }">
            <el-input v-model="item.merchantId" autocomplete="off"></el-input>
          </el-form-item>
          <!-- <el-form-item label="商家名称" prop="merchantName" :label-width="formLabelWidth" :rules="{
            required: true, message: '商家名称不能为空', trigger: 'blur'
          }">
            <el-input v-model="item.merchantName" autocomplete="off"></el-input>
          </el-form-item> -->
          <el-form-item label="申请时间" prop="applicationTime" :label-width="formLabelWidth">
            <el-date-picker v-model="item.applicationTime" type="datetime" format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择申请时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="门店编号" prop="merchantCode" :label-width="formLabelWidth">
            <el-input v-model="item.merchantCode" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="店铺名称" prop="shopName" :label-width="formLabelWidth">
            <el-input v-model="item.shopName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="营业执照" prop="businessLicenseUrl" :label-width="formLabelWidth">
            <div class="draggable-list">
              <draggable class="wrapper" v-model="item.businessLicenseUrl">
                <transition-group>
                  <div class="item" v-for="(item2, index2) in item.businessLicenseUrl" :key="item2.filePath">
                    <img v-img-url="item2.filePath" />
                    <a href="javascript:void(0);" class="delete-btn"
                      @click.stop="deleteImg(index, index2, 'businessLicenseUrl')"><i class="el-icon-close"></i></a>
                  </div>
                </transition-group>
              </draggable>
              <div v-if="!item.businessLicenseUrl.length" class="item img-select"
                @click="openProductUpload('image', 'image', index, 9)"><i class="el-icon-plus"></i></div>
            </div>
          </el-form-item>
          <el-form-item label="营业执照名称" prop="businessLicenseName" :label-width="formLabelWidth">
            <el-input v-model="item.businessLicenseName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="商家姓名" prop="merchantFullName" :label-width="formLabelWidth" :rules="{
            required: true, message: '商家姓名不能为空', trigger: 'blur'
          }">
            <el-input v-model="item.merchantFullName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone" :label-width="formLabelWidth" :rules="{
            required: true, message: '手机号不能为空', trigger: 'blur'
          }">
            <el-input v-model="item.phone" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="经营地址" prop="businessAddress" :label-width="formLabelWidth">
            <el-input v-model="item.businessAddress" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="产品上线方式" prop="productType" :label-width="formLabelWidth">
            <el-select size="small" v-model="item.productType" placeholder="请选择">
              <el-option label="自主上线" value="0"></el-option>
              <el-option label="平台上线" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="item.productType === '0'" label="自主上线链接" prop="independentlyLink"
            :label-width="formLabelWidth">
            <el-input v-model="item.independentlyLink" placeholder="请补充京东商家店铺链接" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item v-if="item.productType === '0'" label="SKU凭证(重要)" prop="independentlyListedImages"
            :label-width="formLabelWidth">
            <div class="draggable-list">
              <draggable class="wrapper" v-model="item.independentlyListedImages">
                <transition-group>
                  <div class="item" v-for="(item2, index2) in item.independentlyListedImages" :key="item2.filePath">
                    <img v-img-url="item2.filePath" />
                    <a href="javascript:void(0);" class="delete-btn"
                      @click.stop="deleteImg(index, index2, 'independentlyListedImages')"><i
                        class="el-icon-close"></i></a>
                  </div>
                </transition-group>
              </draggable>
              <div class="item img-select" @click="openProductUpload('image', 'image', index, 3)"><i
                  class="el-icon-plus"></i></div>
            </div>
          </el-form-item>
          <el-form-item label="群聊二维码" prop="merchantQrCode" :label-width="formLabelWidth">
            <div class="draggable-list">
              <draggable class="wrapper" v-model="item.merchantQrCode">
                <transition-group>
                  <div class="item" v-for="(item2, index2) in item.merchantQrCode" :key="item2.filePath">
                    <img v-img-url="item2.filePath" />
                    <a href="javascript:void(0);" class="delete-btn"
                      @click.stop="deleteImg(index, index2, 'merchantQrCode')"><i class="el-icon-close"></i></a>
                  </div>
                </transition-group>
              </draggable>
              <div v-if="!item.merchantQrCode.length" class="item img-select"
                @click="openProductUpload('image', 'image', index, 1)"><i class="el-icon-plus"></i></div>
            </div>
          </el-form-item>
          <el-form-item label="商家门头照片" prop="merchantPhotos" :label-width="formLabelWidth">
            <div class="draggable-list">
              <draggable class="wrapper" v-model="item.merchantPhotos">
                <transition-group>
                  <div class="item" v-for="(item2, index2) in item.merchantPhotos" :key="item2.filePath">
                    <img v-img-url="item2.filePath" />
                    <a href="javascript:void(0);" class="delete-btn"
                      @click.stop="deleteImg(index, index2, 'merchantPhotos')"><i class="el-icon-close"></i></a>
                  </div>
                </transition-group>
              </draggable>
              <div class="item img-select" @click="openProductUpload('image', 'image', index, 2)"><i
                  class="el-icon-plus"></i></div>
            </div>
          </el-form-item>
          <el-form-item label="实名认证" prop="realNameImages" :label-width="formLabelWidth">
            <div class="draggable-list">
              <draggable class="wrapper" v-model="item.realNameImages">
                <transition-group>
                  <div class="item" v-for="(item2, index2) in item.realNameImages" :key="item2.filePath">
                    <img v-img-url="item2.filePath" />
                    <a href="javascript:void(0);" class="delete-btn"
                      @click.stop="deleteImg(index, index2, 'realNameImages')"><i class="el-icon-close"></i></a>
                  </div>
                </transition-group>
              </draggable>
              <div class="item img-select" @click="openProductUpload('image', 'image', index, 8)"><i
                  class="el-icon-plus"></i></div>
            </div>
          </el-form-item>
          <el-form-item label="测试订单(重要)" prop="testOrderImages" :label-width="formLabelWidth">
            <div class="draggable-list">
              <draggable class="wrapper" v-model="item.testOrderImages">
                <transition-group>
                  <div class="item" v-for="(item2, index2) in item.testOrderImages" :key="item2.filePath">
                    <img v-img-url="item2.filePath" />
                    <a href="javascript:void(0);" class="delete-btn"
                      @click.stop="deleteImg(index, index2, 'testOrderImages')"><i class="el-icon-close"></i></a>
                  </div>
                </transition-group>
              </draggable>
              <div class="item img-select" @click="openProductUpload('image', 'image', index, 5)"><i
                  class="el-icon-plus"></i></div>
            </div>
          </el-form-item>
          <!-- <el-form-item label="上传资质" prop="qualificationsImages" :label-width="formLabelWidth">
            <div class="draggable-list">
              <draggable class="wrapper" v-model="item.qualificationsImages">
                <transition-group>
                  <div class="item" v-for="(item2, index2) in item.qualificationsImages" :key="item2.filePath">
                    <img v-img-url="item2.filePath" />
                    <a href="javascript:void(0);" class="delete-btn"
                      @click.stop="deleteImg(index, index2, 'qualificationsImages')"><i class="el-icon-close"></i></a>
                  </div>
                </transition-group>
              </draggable>
              <div class="item img-select" @click="openProductUpload('image', 'image', index, 7)"><i
                  class="el-icon-plus"></i></div>
            </div>
          </el-form-item> -->
          <el-form-item label="绑定银行卡(重要)" prop="bindingBankCardImages" :label-width="formLabelWidth">
            <div class="draggable-list">
              <draggable class="wrapper" v-model="item.bindingBankCardImages">
                <transition-group>
                  <div class="item" v-for="(item2, index2) in item.bindingBankCardImages" :key="item2.filePath">
                    <img v-img-url="item2.filePath" />
                    <a href="javascript:void(0);" class="delete-btn"
                      @click.stop="deleteImg(index, index2, 'bindingBankCardImages')"><i class="el-icon-close"></i></a>
                  </div>
                </transition-group>
              </draggable>
              <div class="item img-select" @click="openProductUpload('image', 'image', index, 6)"><i
                  class="el-icon-plus"></i></div>
            </div>
          </el-form-item>
          <el-form-item label="签约京东钱包(重要)" prop="jdWalletImages" :label-width="formLabelWidth">
            <div class="draggable-list">
              <draggable class="wrapper" v-model="item.jdWalletImages">
                <transition-group>
                  <div class="item" v-for="(item2, index2) in item.jdWalletImages" :key="item2.filePath">
                    <img v-img-url="item2.filePath" />
                    <a href="javascript:void(0);" class="delete-btn"
                      @click.stop="deleteImg(index, index2, 'jdWalletImages')"><i class="el-icon-close"></i></a>
                  </div>
                </transition-group>
              </draggable>
              <div class="item img-select" @click="openProductUpload('image', 'image', index, 4)"><i
                  class="el-icon-plus"></i></div>
            </div>
          </el-form-item>
        </el-form>
        <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">
          上传图片</Upload>
      </div>
      <el-button class="btn_add" type="primary" @click="copy">再加一条</el-button>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import jingdongApi from '@/api/plus/jingdong.js';
import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';
export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      formLabelWidth: '120px',
      loading: false,
      dialogVisible: true,
      formData: [
        {
          merchantId: '',
          merchantName: '',
          productType: null,
          merchantQrCode: [],
          merchantPhotos: [],
          applicationTime: '',
          merchantCode: '',
          shopName: '',
          businessLicenseName: '',
          merchantFullName: '',
          phone: '',
          businessAddress: '',
          realNameImages: [],
          independentlyLink: '',
          businessLicenseUrl: []
        }
      ],
      isProductUpload: false,
      config: {},
      file_name: 'image',
      uploadIndex: 0,
      uploadType: 1
    }
  },
  props: ['form', 'userid'],
  created() {
  },
  methods: {
    copy() {
      this.formData.push({
        merchantId: '',
        merchantName: '',
        productType: null,
        merchantQrCode: [],
        merchantPhotos: [],
        applicationTime: '',
        merchantCode: '',
        shopName: '',
        businessLicenseName: '',
        merchantFullName: '',
        phone: '',
        businessAddress: '',
        realNameImages: [],
        independentlyLink: '',
        businessLicenseUrl: []
      });
    },
    deleteImg(index, index2, name) {
      this.formData[index][name].splice(index2, 1);
    },

    openProductUpload(file_type, file_name, index, type) {
      this.uploadType = type
      this.uploadIndex = index
      this.file_name = file_name;
      if (file_type == 'image') {
        this.config = {
          total: 9,
          fileType: 'image'
        };
      } else {
        this.config = {
          total: 1,
          fileType: 'video'
        };
      }
      this.isProductUpload = true;
    },
    returnProductImgsFunc(e) {
      console.log(e)
      if (e != null) {
        console.log(this.uploadIndex)
        console.log(this.file_name)
        let imgs = []
        if (this.uploadType === 1) {
          imgs = [e[0]]
        } else if (this.uploadType === 2) {
          imgs = this.formData[this.uploadIndex].merchantPhotos.concat(e);
        }
        else if (this.uploadType === 3) {
          imgs = this.formData[this.uploadIndex].independentlyListedImages.concat(e);
        }
        else if (this.uploadType === 4) {
          imgs = this.formData[this.uploadIndex].jdWalletImages.concat(e);
        }
        else if (this.uploadType === 5) {
          imgs = this.formData[this.uploadIndex].testOrderImages.concat(e);
        }
        else if (this.uploadType === 6) {
          imgs = this.formData[this.uploadIndex].bindingBankCardImages.concat(e);
        }
        else if (this.uploadType === 7) {
          imgs = this.formData[this.uploadIndex].qualificationsImages.concat(e);
        }
        else if (this.uploadType === 8) {
          imgs = this.formData[this.uploadIndex].realNameImages.concat(e);
        }
        else if (this.uploadType === 9) {
          imgs = this.formData[this.uploadIndex].businessLicenseUrl.concat(e);
        }
        for (let i = 0; i < imgs.length; i++) {
          if (typeof (imageId) == "undefined") {
            this.$set(imgs[i], 'imageId', imgs[i].fileId);
          }
        }
        if (this.uploadType === 1) {
          this.$set(this.formData[this.uploadIndex], 'merchantQrCode', imgs);
        } else if (this.uploadType === 2) {
          this.$set(this.formData[this.uploadIndex], 'merchantPhotos', imgs);
        }
        else if (this.uploadType === 3) {
          this.$set(this.formData[this.uploadIndex], 'independentlyListedImages', imgs);
        }
        else if (this.uploadType === 4) {
          this.$set(this.formData[this.uploadIndex], 'jdWalletImages', imgs);
        }
        else if (this.uploadType === 5) {
          this.$set(this.formData[this.uploadIndex], 'testOrderImages', imgs);
        }
        else if (this.uploadType === 6) {
          this.$set(this.formData[this.uploadIndex], 'bindingBankCardImages', imgs);
        }
        else if (this.uploadType === 7) {
          this.$set(this.formData[this.uploadIndex], 'qualificationsImages', imgs);
        }
        else if (this.uploadType === 8) {
          this.$set(this.formData[this.uploadIndex], 'realNameImages', imgs);
        }
        else if (this.uploadType === 9) {
          this.$set(this.formData[this.uploadIndex], 'businessLicenseUrl', imgs);
          this.getOcrResult(this.uploadIndex, imgs[0].filePath)
        }
      }
      this.isProductUpload = false;
    },
    getOcrResult(index, url) {
      console.log(index)
      console.log(url)
      jingdongApi.JdMerchantocr({
        url: url
      }, true)
        .then(res => {
          console.log(res)
          if (res.code === 1) {
            this.$set(this.formData[this.uploadIndex], 'businessLicenseName', res.data.companyName);
            this.$set(this.formData[this.uploadIndex], 'businessAddress', res.data.businessAddress);
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
    submit() {
      let self = this;
      let promises = [];
      self.formData.forEach((item, index) => {
        const formRef = self.$refs['valiForm' + index];
        promises.push(
          formRef[0]
            .validate()
            .then((res) => {
              return res;
            })
            .catch((err) => {
              return Promise.reject(err);
            })
        );
      });

      Promise.all(promises)
        .then((results) => {
          console.log('所有表单校验成功', results);
          console.log(self.formData);
          let params = JSON.parse(JSON.stringify(self.formData));
          params.forEach((item) => {
            let arr = [];
            item.merchantPhotos.forEach((item2) => {
              arr.push(item2.imageId);
            });
            item.merchantPhotos = arr;
            if (item.merchantQrCode && item.merchantQrCode.length) {
              item.merchantQrCode = item.merchantQrCode[0].imageId;
            } else {
              item.merchantQrCode = ''
            }
            item.createBy = self.userid
          });
          console.log(params);
          self.loading = true;
          jingdongApi.shopSaveUserJdMerchant({
            jdMerchants: params
          }, true)
            .then(data => {
              self.loading = false;
              console.log(data)
              if (data.data === '1') {
                self.$message({
                  message: data.msg,
                  type: 'warning'
                });
                self.dialogFormVisible(true);
              } else {
                self.$message({
                  message: '商家添加成功',
                  type: 'success'
                });
                self.dialogFormVisible(true);
              }

            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch((error) => {
          console.log('请将表单填写完整')
        });

    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      this.$emit('closeDialog', {
        type: 'success',
        openDialog: false
      })
    }

  }
};
</script>

<style lang="scss" scoped>
.btn_add {
  margin: 0 auto;
  width: 470px;
  display: block;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper>span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/user/user/dialog/JdMerchant.vue